var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoMapBookMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.693 4.28906L9.93945 5.42995V20.4726L11.4072 20.1203V14C11.4072 12.0861 12.841 10.5071 14.693 10.2785V4.28906Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.312 12.9287C21.8511 11.3796 20.4161 10.25 18.7173 10.25H16.193V4.2947L20.5972 5.37331C21.604 5.61987 22.312 6.52225 22.312 7.55873V12.9287Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43945 5.42642V20.4707L4.02728 19.3902C3.02055 19.1436 2.3125 18.2413 2.3125 17.2048V6.79344C2.3125 5.33411 3.68027 4.26089 5.09771 4.60802L8.43945 5.42642Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.1572 11.75C13.9146 11.75 12.9072 12.7574 12.9072 14V21.75C12.9072 22.0284 13.0614 22.2839 13.3077 22.4136C13.554 22.5433 13.8519 22.5259 14.0815 22.3685L16.513 20.7005C16.7687 20.5252 17.1059 20.5252 17.3615 20.7005L19.793 22.3685C20.0226 22.5259 20.3205 22.5433 20.5668 22.4136C20.8131 22.2839 20.9673 22.0284 20.9673 21.75V14C20.9673 12.7574 19.9599 11.75 18.7173 11.75H15.1572Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoMapBookMark);
export default __webpack_public_path__ + "static/media/DuoMapBookMark.b6a4201db90da10d7565ad5014a50498.svg";
export { ForwardRef as ReactComponent };